module.exports = __webpack_public_path__ + "static/media/wn_21.869b5fb5.jpg";